// mutations
const SET_RESULTHEALTH = (state, payload) => {
  state.list_health = payload;
};
const SET_INPUTMASTERHEALTH = (state, payload) => {
  state.tempMasterHealth = payload;
};
const SET_IDMASTERHEALTH = (state, payload) => {
  state.idMasterHealth = payload;
};
const SET_USERID = (state, payload) => {
  state.id_user = payload;
};
const SET_RESMEDICALCATE = (state, payload) => {
  state.res_medicCate = payload;
};
const SET_TEMPHEALTH = (state, payload) => {
  state.temp_userHealth = payload;
};
const SET_RESHEALTHUSER = (state, payload) => {
  state.res_health = payload;
};
const SET_IDHEALTH = (state, payload) => {
  state.id_health = payload;
};
export default {
  SET_RESULTHEALTH,
  SET_INPUTMASTERHEALTH,
  SET_IDMASTERHEALTH,
  SET_RESMEDICALCATE,
  SET_USERID,
  SET_TEMPHEALTH,
  SET_RESHEALTHUSER,
  SET_IDHEALTH
};
